import React from 'react';
import { CreateTripModal } from './createTripModal';
import { useMyTripsData } from '../../hooks/myTrips/useMyTripsData';
import { useCreateTripModal } from '../../hooks/myTrips/useCreateTripModal';
import { useMyTripsNavigation } from '../../hooks/myTrips/useMyTripsNavigation';
import { MyTripsHeader } from './MyTripsHeader';
import { MyTripsGrid } from './MyTripsGrid';

/**
 * My Trips page component - refactored to separate business logic from UI.
 * All business logic is now in custom hooks, making it reusable for React Native.
 */
export const MyTripsPage = React.memo(() => {
  // Business logic hooks (platform-agnostic)
  const { trips, isLoading, latestTrip, heroImage, hasTrips } = useMyTripsData();
  const modal = useCreateTripModal();

  // Web-specific navigation hook
  const { navigateToEditTrip } = useMyTripsNavigation();

  // Handlers
  const handleContinueLatestTrip = () => {
    if (latestTrip) {
      navigateToEditTrip(latestTrip.id);
    }
  };

  return (
    <div className="min-h-screen bg-subtle">
      <MyTripsHeader
        heroImage={heroImage}
        isLoading={isLoading}
        latestTripTitle={latestTrip?.title}
        onCreateTrip={modal.open}
        onContinueTrip={latestTrip ? handleContinueLatestTrip : undefined}
      />

      <MyTripsGrid
        trips={trips}
        isLoading={isLoading}
        hasTrips={hasTrips}
        onCreateTrip={modal.open}
      />

      <CreateTripModal open={modal.isOpen} setOpen={modal.setIsOpen} />
    </div>
  );
});
